import { Edit } from "react-admin";
import * as React from "react";
import { HomeBannersCreateForm } from "./HomeBannersCreate";

export const HomeBannersEdit = () => (
  <Edit>
    <HomeBannersCreateForm />
  </Edit>
);
